import React, { useState } from "react";
import Colors from "../../config/colors.js";
import Grid from "@material-ui/core/Grid";

const Card = (props) => {
  const image =
    props.image !== null && !props.image.uri.includes("transparentcard.png")
      ? props.image
      : null;
  const fontColor = {
    front:
      props.bgcolor === "lightGreen" && image === null ? "#225C4C" : "#fff",
    back: props.bgcolor === "lightGreen" || image !== null ? "#fff" : "#225C4C",
  };
  const bgColor = {
    front: Colors[props.bgcolor],
    back: props.bgcolor === "lightGreen" ? Colors.darkGreen : Colors.lightGreen,
  };
  const [show, setShow] = useState(true);
  const [count, setCount] = useState(0);
  const cardStyle = {
    height: "100%",
    display: "inlineBlock",
    position: "relative",
    borderRadius: "16px",
    boxShadow:
      "0 3px 3px -2px rgba(0,0,0,0.2), 0 3px 4px 0 rgba(0,0,0,0.14), 0 1px 8px 0 rgba(0,0,0,0.12)",
  };
  const cardClick = () => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      if (count === 0) {
        setShow(false);
        setCount(count + 1);
      } else if (count === 1) {
        setShow(true);
        setCount(0);
        window.location = props.link;
      }
    } else window.location = props.link;
  };
  return (
    <Grid
      item
      xs={props.xs}
      sm={props.sm}
      md={props.md}
      lg={props.lg}
      style={{
        boxSizing: "border-box",
      }}
      onMouseEnter={() => setShow(false)}
      onMouseLeave={() => setShow(true)}
      onClick={() => cardClick()}
    >
      <div
        tabIndex="-1"
        style={{
          ...cardStyle,
          backgroundColor: show !== true ? bgColor.back : bgColor.front,
          transitionTimingFunction: "ease",
          transition: "background .5s",
        }}
      >
        <img
          src={
            image === null
              ? "https://content.uvm.edu/shared/files/styles/1200/public/focus/sustainability/cards/transparentcard.png"
              : props.image.uri
          }
          alt=""
          style={{
            width: "100%",
            height: "auto",
            margin: 0,
            borderRadius: "16px",
          }}
        />
        <div
          className="overlay"
          style={{
            cursor: show === false ? "pointer" : "default",
            borderRadius: "16px",
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            background:
              show !== true && image !== null
                ? "rgb(1, 83, 63,.8)"
                : image !== null
                ? "linear-gradient(to bottom, rgb(0,0,0,0), rgb(0,0,0,0),rgb(0,0,0,.5),rgb(0,0,0,0))"
                : null,
            transitionTimingFunction: "ease",
            transition: "background .5s",
          }}
        ></div>
        <div
          style={{
            cursor: props.link === null ? "default" : "pointer",
            ariaHidden: "true",
            borderRadius: "16px",
            position: "absolute",
            top: "55%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            textTransform: show === true ? "uppercase" : "none",
            fontWeight: show === true ? 400 : 600,
            fontFamily: show === true ? "Oswald" : "Roboto",
            fontSize: show === true ? "18px" : "16px",
            letterSpacing: show === true ? "0.7px" : "0",
            lineHeight: show === true ? "24px" : "24px",
            textAlign: "center",
            color: show === true ? fontColor.front : fontColor.back,
          }}
        >
          {show === true ? props.front : props.back + " →"}
        </div>
        <div
          style={{
            cursor: props.link === null ? "default" : "pointer",
            position: "absolute",
            top: 0,
            opacity: "0",
            height: "1px",
            width: "1px",
          }}
        >
          {props.front}
          {props.back}
        </div>
      </div>
    </Grid>
  );
};

export default Card;
